import styled from 'styled-components'
import { DeviceTypes } from '../../../types/state'

interface Props {
	isSelected: boolean
}

export const UserDetailsWrapper = styled.div<{ device: DeviceTypes }>`
	justify-content: space-evenly;
	display: flex;
	flex-flow: column;
	// height: ${({ device }) => (device === DeviceTypes.MOBILE ? '' : '')};
	// background-color: var(--form-bg-color);
	// border-radius: var(--border-radius-lg);
	padding: ${({ device }) => (device === DeviceTypes.MOBILE ? '' : '30px')};
	width: ${({ device }) => (device === DeviceTypes.MOBILE ? '100%' : '40%')};
	margin-left: auto;
	margin-right: auto;
`

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	--btn-width: 92%;
	--btn-bg-color: var(--btn-color);
	--btn-bg-disabled: var(--btn-color-disabled);
	--btn-text-color: var(--text-color);
	--btn-text-disabled: var(--text-color-disabled);
	--btn-border-radius: var(--border-radius-sm);
	--btn-height: var(--it-hg-lg);
	width: 80%;
	margin-top: var(--mg-sm);
	margin-bottom: var(--mg-xs);
`

export const ButtonText = styled.span`
	letter-spacing: 0.46px;
	font-size: var(--fs-sm);
	font-weight: var(--fw-md);
`
export const Form = styled.div`
	display: flex;
	flex-flow: column;
	justify-content: space-around;
	align-items: center;
`

export const Radio = styled.input`
	color: transparent;
	position: absolute;
	opacity: 0;
	cursor: pointer;
	margin-left: 2vh;
	+ *::before {
		content: '';
		display: inline-block;
		vertical-align: bottom;
		width: 1rem;
		height: 1rem;
		margin-right: 0.3rem;
		border-radius: 50%;
		border-style: solid;
		border-width: 0.1rem;
		border-color: var(--border-color);
	}
	:checked + *::before {
		background: radial-gradient(
			var(--btn-color) 0%,
			var(--btn-color) 40%,
			transparent 50%,
			transparent
		);
		border-color: var(--btn-color);
	}
`

export const Text = styled.label`
	margin-top: 0.8em;
	font-size: 16px;
	padding: 0px 10px;
	text-transform: CAPITALIZE;
	color: #fff;
`

export const ErrorMessage = styled.span`
	align-self: start;
	color: var(--btn-color);
	font-size: var(--fs-xxs);
	margin-left: var(--mg-xs);
	margin-bottom: 15px;
`

export const Textarea = styled.textarea`
	width: 91%;
	background: transparent;
	letter-spacing: 0.15px;
	height: var(--it-hg-lg);
	border-radius: var(--border-radius-xs);
	border: 1px solid var(--border-color);
	color: var(--text-white-color);
	font-size: var(--fs-sm);
	font-weight: var(--fw-sm);
	margin: var(--mg-xs) 0px;
	&::placeholder {
		padding-top: 10px;
		font-family: var(--font);
		color: var(--placeholder-color);
		font-size: var(--fs-sm);
		font-weight: var(--fw-sm);
		margin: auto;
		line-height: 10px;
		padding-left: 10px;
	}
`

export const Input = styled.input`
	width: 88%;
	background-color: transparent;
	padding-left: 10px;
	letter-spacing: 0.15px;
	height: var(--it-hg-lg);
	border-radius: var(--border-radius-xs);
	border: 1px solid var(--border-color);
	color: var(--text-white-color);
	font-size: var(--fs-sm);
	font-weight: var(--fw-sm);
	&:focus {
		outline: none;
	}
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`

export const Gender = styled.div`
	display: flex;
	/* margin: 50px 0px 50px 0px; */
	margin: 0;
	/* padding: 30px 40px 0 40px; */

	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px 10px 20px;
	gap: 15px;
`

export const Heading = styled.h1`
	font-size: 24px;
	color: white;
`

export const Image = styled.img<Pick<Props, 'isSelected'>>`
	width: 66px;
	height: 66px;
	margin-top: 5px;
	margin-left: 10px;
	transform: ${(props) => (props.isSelected ? 'scale(1.6)' : 'scale(1.2)')};
	&:hover {
		transform: scale(1.6);
	}
`

export const LocationButton = styled.button`
	background: var(--btn-color);
	border: 1px solid var(--btn-color);
	border-radius: var(--border-radius-sm);
	color: var(--text-color);
	padding: 10px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 60%;
	align-self: center;
	margin: var(--mg-sm);
	font-family: var(--font);
	font-weight: var(--fw-md);
`

export const RadioImage = styled.label``

export const RadioImageInput = styled.input`
	display: none;
`

export const GenderOption = styled.label`
	width: 100%;
	background: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
	/* padding: 0 20px 0 20px; */
	border: 1px solid #cecedf;
	border-radius: 8px;
	padding: 0 25px 0px 25px;
	box-sizing: border-box;
`

export const GenderText = styled.p<Pick<Props, 'isSelected'>>`
	color: ${(props) => (props.isSelected ? '#000042' : '#333368')};
	font-weight: ${(props) => (props.isSelected ? '700' : '400')};
`
